import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorBlackTransparent600, colorBlackTransparent800, colorCoreWhite1000, } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
import { SCROLL_BUTTON_TRANSITION } from './constants';
export const ScrollUpButtonStyled = styled(Button) `
  position: ${({ isButtonInBottom }) => (isButtonInBottom ? 'absolute' : 'fixed')};
  bottom: ${({ isCompareProductsShown }) => (isCompareProductsShown ? '130px' : '20px')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 20px;' : 'right: 20px;')}

  z-index: ${Z_INDEX.level7};
  transition: ${SCROLL_BUTTON_TRANSITION};

  background-color: ${colorBlackTransparent600};

  &:hover {
    background-color: ${colorBlackTransparent800};

    svg > path {
      fill: ${colorCoreWhite1000};
    }
  }

  svg > path {
    fill: ${colorCoreWhite1000};
  }
`;
